import { GetStaticPaths } from 'next'
import { getAuthorProps } from 'props-getters/author'
import { ExtractGetterProps } from 'shared-definitions/util-types'
import PageContainer from 'shared-components/service/PageContainer'
import AuthorTemplate from 'shared-components/templates/AuthorTemplate'
import Layout from 'components/Layout'
import { getds } from 'ds'
import { useCallback } from 'react'
import { DSPostShort, DSPostShortWithAuthor } from 'shared-definitions/types'
import styleUtils from 'shared-components/styles/util.module.css'
import PlaywireTagged from 'shared-components/ad/PlaywireTagged'

const AuthorPage: React.VFC<ExtractGetterProps<typeof getAuthorProps>> = ({
  preview,
  page,
  common,
  ts,
}) => {
  const augmenter = useCallback(
    (from: DSPostShort): DSPostShortWithAuthor => ({ ...from, author: page.author }),
    [page.author]
  )
  const pageLoader = useCallback(
    async (pageNumber: number, perPage: number) => {
      const dataSource = await getds({ ts })
      const result = await dataSource.getAuthorPage(page.slug, pageNumber, perPage)
      if (!result.data || result.data.resource === 'redirect') {
        return []
      }
      return result.data.posts.items.map(augmenter)
    },
    [page.slug, ts, augmenter]
  )

  return (
    <PageContainer layout={Layout} props={{ page, common, ts, preview }} layoutProps={{}}>
      <AuthorTemplate
        sideBar={<PlaywireTagged className={styleUtils.sidebarEl} type="med_rect_atf" />}
        page={page}
        pageLoader={pageLoader}
        augmenter={augmenter}
      />
    </PageContainer>
  )
}

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export const getStaticProps = getAuthorProps()

export default AuthorPage
